import * as React from "react";
import { Text, TextVariant } from "../../../ui";
import { ColorGradeIcon, ColorGradeOption } from "../../../PreJobChecklistV2/colorGradeHelpers";

export const ReadingCells: React.FC<{ label: string; value: string; grade?: ColorGradeOption | null }> = ({
  label,
  value,
  grade,
}) => (
  <>
    <Text as="span" variant={TextVariant.BODY2} className="text-gray-400">
      {label}
    </Text>
    <span className="flex items-center gap-1.5">
      {/* The inspection form's own severity icon first, so the grade reads before the detail. */}
      {grade ? (
        <span role="img" aria-label={`${grade} severity`} title={`${grade} severity`} className="flex shrink-0">
          <ColorGradeIcon colorGrade={grade} />
        </span>
      ) : null}
      <Text as="span" variant={TextVariant.BODY2} style={{ fontWeight: 600 }}>
        {value}
      </Text>
    </span>
  </>
);
